import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Keep French punctuation (?, !, :, ;) with the preceding word to avoid orphans. */
export function preventOrphanPunctuation(text: string): string {
  return text
    .replace(/[\u0020\u00A0\u202F]+([?!:;])/g, '\u00A0$1')
    .replace(/([?!:;])\u00A0*$/g, '$1')
}
